import { AIInputWithSuggestions } from "@/components/ui/ai-input-with-suggestions";
import { Flex, Text } from "@radix-ui/themes";

export function AiExplore() {
  return (
    <Flex className="flex flex-col gap-4  h-full mt-32 px-16">
      <AIInputWithSuggestions
        placeholder="write me something"
        onSubmit={(v) => {
          alert(v);
        }}
      />
    </Flex>
  );
}
